module.exports = __webpack_public_path__ + "img/Logo-eDoatap_Color_white-letters.dc896579.png";